export default __webpack_public_path__ + "static/media/sin-desactivar.8e4eddad.svg";